import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import React from "react";
import { useNavigate } from "react-router";
import AppButton from "src/components/common/AppButton";
import { useLocales } from "src/locales";
import { paths } from "src/routes/paths";
import { deleteLocalStorageKeys } from "src/utils/storage-available";

const TelegramBotPage: React.FC = () => {
  const { t } = useLocales();
  const navigate = useNavigate();

  return (
    <Grid
      container
      spacing={1}
      direction="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      <Grid item xs={12} md={6}>
        <Typography fontSize={24} fontWeight={500} mb={2}>
          {t("telegramBot.title")}
        </Typography>
        <Grid item container spacing={2} alignItems="center" mb={2}>
          <Grid item>
            <Box component="img" alt="auth" src={"/assets/telegramBotLogo.png"} />
          </Grid>
          <Grid item>
            <Typography fontSize={24} fontWeight={500}>
              {t("login.title")}
            </Typography>
          </Grid>
        </Grid>
        <Typography
          fontSize={16}
          fontWeight={400}
          width={{ md: 746 }}
          paragraph
          textAlign="justify"
        >
          {t("telegramBot.description")}
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{ borderRadius: "12px", p: 3, bgcolor: "background.paper", mt: 2 }}
        flexDirection="column"
        alignItems={{ xs: "center", md: "baseline" }}
      >
        <Typography variant="subtitle1" fontWeight={400} mb={1}>
          {t("telegramBot.subtitle")}
        </Typography>

        <Typography variant="subtitle1" fontWeight={400} pl={1}>
          {t("telegramBot.subtitle1")}
        </Typography>

        <Typography variant="subtitle1" fontWeight={400} mb={3} pl={1}>
          {t("telegramBot.subtitle2")}
        </Typography>
        <Box display="flex" gap={2}>
          <Link href="https://t.me/DaysOfIman_Bot" target="_blank">
            <AppButton label={t("telegramBot.button")} color="secondary" sx={{ pl: 1 }} />
          </Link>
          <AppButton
            sx={{ py: 2, px: 7, border: "2px solid black" }}
            label={t("telegramBot.close")}
            onClick={() => {
              navigate(paths.auth.jwt.login);
              deleteLocalStorageKeys();
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default TelegramBotPage;
